import { takeLatest } from 'redux-saga'
import {
	select,
	put,
} from 'redux-saga/effects'

import actionTypes from 'redux/actions/actionTypes'
import callAny from './helpers/call_any'
import lessonSessionSelector from 'redux/selectors/lessons/lesson_session_selector'
import lessonSessionActions from 'redux/actions/lessonSessionActions'
import lessonSessionSync from 'sync/lesson_session_sync'

function *getLessonMetaData(action) {
	try {
		const sessionData = yield select(lessonSessionSelector)
		if (!sessionData.metadata) {
			const sesionMetadataResponse = yield callAny(
				lessonSessionSync.getLessonMetadata,
				action.session.presentation_uid,
				action.session.headers,
			)
			yield put(lessonSessionActions.metadataSuccess(
				sesionMetadataResponse.payload
			))
		}

	} catch (error) {
		//
	}
}

export default [
	takeLatest([
		actionTypes.STUDENT_INITIALIZE_READ_ONLY,
	], getLessonMetaData),
]

export {
	getLessonMetaData,
}
